/* eslint-disable import/first */
import React, { useEffect, useCallback } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;

import { useIntl } from 'react-intl';

const { selectDefaultAddress } = Slices.addressSlice;
const { fetchProductsByCategoryId } = Slices.productSlice;
const { getClusterId } = Slices.configSlice;

const { currentCategory } = Slices.categorySlice;

import CategoryWrapper from './CategoryWrapper';
import RefreshCartValues from '../../components/MiniCart/RefreshCartValues';
import CategoryBreadcrumbs from '../../components/SeoTitle/CategoryBreadcrumbs';

function Category({ encodedCategoryName, categoryID, locale, navigate }) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const address = useSelector(selectDefaultAddress);
  const clusterId = useSelector(getClusterId);

  const favtCategory = categoryID == 999 ? true : false;

  const fetchCategory = useCallback(() => {
    if (!favtCategory) {
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!categoryID) {
        // dispatch(setCurrentCat(categoryID));
      }
      // if (!selectedProdListByCat[currentCatId]?.length) {
      dispatch(
        fetchProductsByCategoryId({
          id: categoryID,
          cluster: clusterId,
          Language: intl.locale.charAt(0).toUpperCase() + intl.locale.slice(1),
          service: address.addressSubType || 'DELIVERY',
        })
      );
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryID]);
  useEffect(() => {
    const timeoutBegins = window.setTimeout(fetchCategory, 10);
    return () => clearTimeout(timeoutBegins);
    // fetchCategory();
  }, [fetchCategory, categoryID]);
  // HANDLEE TAB SELECTION

  return (
    <>
      <CategoryBreadcrumbs categoryID={categoryID} />
      <RefreshCartValues />
      <CategoryWrapper
        encodedCategoryName={encodedCategoryName}
        categoryID={categoryID}
        locale={locale}
        navigate={navigate}
      />
    </>
  );
}

export default Category;
